import React from "react";
import styles from "./FormikCustomInput.module.scss";
import {FastField} from 'formik';
import Label from './components/label';
import {Unless} from 'react-if';
import CustomTextField from "../customTextField/CustomTextField";
import FormErrorDisplay from "../formErrorDisplay/FormErrorDisplay";

interface IFormikCustomInputProps {
  name: string;
  label: string | any;
  className?: string;
  InputProps?: any;
  inputComponent?: any;
  hideLabel?: boolean;
}

export const CustomizedTextField = (props: any) => {
  const touched = props.form.touched[props.field.name];
  const error = touched && props.form.errors[props.field.name];
  const value = props.field.value;
  const valid = touched && !error || (isNaN(value) ? false : value > props.min);
  return (
    <div className={`${styles.CustomizedTextField} ${error ? styles.fieldError : ''} ${props.className}`.trim()}>
      <Unless condition={props.hideLabel || !props.label}>
        {() => <Label label={props.label}/>}
      </Unless>
      {typeof props.inputComponent === 'function' ? props.inputComponent(props) : props.inputComponent}
      <FormErrorDisplay error={error}/>
    </div>
  );
}

CustomizedTextField.defaultProps = {
  className: '',
  field: {value: ''},
  form: {touched: {}, errors: {}}
};

const FormikCustomInput = (props: IFormikCustomInputProps) => (
  <FastField
    component={CustomizedTextField}
    id={props.name}
    {...props}
  />
);

FormikCustomInput.defaultProps = {
  name: "",
  label: "",
  inputComponent: props => <CustomTextField {...props.field}/>,
  hideLabel: false,
};

export default FormikCustomInput;
